import { useState } from 'react';
import { useRouteMatch } from 'react-router';

import { useTelephony } from './useTelephony';
import { Loading } from '../../../components';
import { Card, Form, FormItem, Input } from '../../../components';
import { Button, SubmitButton, PhonesInput } from '../../../components';
import type { AgentTelephonyFormType } from './useTelephony';

type OutboundTabComponentProps = ReturnType<typeof useTelephony> & {
  disabled?: boolean;
};

export const OutboundTabComponent: React.FC<OutboundTabComponentProps> = ({
  form,
  updating,
  disabled = false,

  updateTelephony,
  addOutboundPhonenumber,
  deleteOutboundPhonenumber,
}) => {
  const [values, setValues] = useState(form);
  const { params } = useRouteMatch<{ organization_id: string }>();

  return (
    <Form<AgentTelephonyFormType> initialValue={values} onChange={setValues}>
      <div className="flex flex-col mt-md gap-y-md max-w-[50rem] mx-auto">
        <Card
          collapsable
          size="unset"
          withOverflow={false}
          name="telephony.out.card0"
          defaultCollapsed={false}
          contentClassName="flex flex-col gap-y-md"
        >
          <FormItem<AgentTelephonyFormType>
            required
            name="integrationName"
            label="Outbound SIP trunk integration name"
            inline={false}
          >
            <Input disabled={disabled} />
          </FormItem>
        </Card>
        <Card
          collapsable
          size="unset"
          withOverflow={false}
          name="telephony.out.card1"
          defaultCollapsed={false}
          title="Take from your SIP trunk provider"
          contentClassName="flex flex-col gap-y-md"
        >
          <FormItem<AgentTelephonyFormType>
            name="username"
            label="User Name"
            required
            inline={false}
          >
            <Input disabled={disabled} />
          </FormItem>
          <FormItem<AgentTelephonyFormType>
            name="password"
            label="Password"
            required
            inline={false}
          >
            <Input disabled={disabled} type="password" />
          </FormItem>
          <FormItem<AgentTelephonyFormType>
            name="sipAddress"
            label="SIP Address"
            required
            inline={false}
          >
            <Input disabled={disabled} />
          </FormItem>

          <div className="flex flex-row gap-x-md justify-end items-center">
            <Button
              label="Cancel"
              url={`/agents/${params.organization_id}`}
              type="contrast"
              size="medium"
            />
            <SubmitButton
              label="Save"
              size="medium"
              type="primary"
              loading={updating}
              disabled={updating}
              onClick={() => updateTelephony(values as AgentTelephonyFormType)}
            />
          </div>
        </Card>
        <Card
          collapsable
          size="unset"
          withOverflow={false}
          name="telephony.out.card2"
          defaultCollapsed={false}
          contentClassName="flex flex-col gap-y-md"
        >
          <FormItem<AgentTelephonyFormType>
            name="outboundPhones"
            label="Phone number"
            inline={false}
          >
            <PhonesInput
              disabled={disabled}
              loading={updating}
              values={form.outboundPhones}
              onAdd={addOutboundPhonenumber}
              onDelete={deleteOutboundPhonenumber}
            />
          </FormItem>
        </Card>
      </div>
    </Form>
  );
};

export const OutboundTab: React.FC = () => {
  const { loading, ...rest } = useTelephony();

  if (loading) return <Loading />;

  return <OutboundTabComponent loading={loading} {...rest} />;
};

export default OutboundTab;
